import { gql } from 'apollo-boost'

export const CHANGE_USER_NAME = gql`
  mutation ChangeUserName($input: UpdateUserNicknameInput!) {
    updateUserNickname(input: $input) {
      nickname
    }
  }
`
